import React, { createContext, useContext, useEffect, useState, ReactNode } from "react";

interface TimerContextValue {
  tick: number;
}

const TimerContext = createContext<TimerContextValue>({ tick: 0 });

/**
 * Провайдер с одним интервалом (раз в секунду).
 * Все OrderStatusProgress внутри него будут обновляться синхронно.
 */
export const TimerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTick((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <TimerContext.Provider value={{ tick }}>
      {children}
    </TimerContext.Provider>
  );
};

/** Хук для получения текущего тика таймера */
export const useTimer = () => useContext(TimerContext);
